import React, {useEffect} from 'react'
import {connect} from 'react-redux'
//  page wraper
import RaportsPage from 'views/LoggedUserPages/Raports/RaportsPage'
import RaportVisualization from './RaportVisualization'
import {
    getReport0, getReport1, getCode1, getReport2, getReport31, getCode31, getReport32, getCode32, getReport4, getCode4,
    getReport5, getCode5, getReport6, getCode6, getReport7, getReport8, getReport9, getReport10, getReportNew0
} from 'actions/reportActions';
import {getOpkNumbers, getOpkNumbers7, getOpkNames, getOpkNumbersProc, getOpkNamesProc} from 'actions/filterOpkActions';
// import ReportTable from 'components/ReactTable/ReportTable';
import Report0 from 'components/ReactTable/Report0';
import Report1 from 'components/ReactTable/Report1';
import Report2 from 'components/ReactTable/Report2';
import Report31 from 'components/ReactTable/Report31';
import Report32 from 'components/ReactTable/Report32';
import Report4 from 'components/ReactTable/Report4';
import Report5 from 'components/ReactTable/Report5';
import Report6 from 'components/ReactTable/Report6';
import Report7 from 'components/ReactTable/Report7';
import Report8 from 'components/ReactTable/Report8';
import Report9 from 'components/ReactTable/Report9';
import Report10 from 'components/ReactTable/Report10';
import Spinner from 'components/common/Spinner';
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {registerLocale} from "react-datepicker";
import pl from 'date-fns/locale/pl';
import moment from 'moment';
// reactstrap components
import {
    Card, CardHeader, CardBody, CardTitle,
    Row, Col,
    Button, ButtonGroup,
    FormGroup, Collapse, Input, Label
} from "reactstrap";
import ReactDatetime from "react-datetime";
import {getOpkFull} from "../../../actions/filterOpkActions";

//resort name czy name ?
const NewRaport = (props) => {
    //props destructor
    const {
        reportLoading, nestedLoading,
        getReport0, report0,
        getReport1, report1, getCode1,
        getReport2, report2,
        getReport31, report31, getCode31,
        getReport32, report32, getCode32,
        getReport4, report4, getCode4, 
        getReport5, report5, getCode5,
        getReport6, report6, getCode6,
        getReport7, report7,
        getReport8, report8,
        report82,
        getReport9, report9,
        getReport10, report10,
        OpkFull,
        getOpkNumbers, OpkNumbers, OpkNumbersLoading,
        getOpkNumbers7, OpkNumbers7, OpkNumbers7Loading,
        getOpkNames, OpkNames, OpkNamesLoading,
        getOpkNumbersProc, OpkNumbersProc, OpkNumbersLoadingProc,
        getOpkNamesProc, OpkNamesProc, OpkNamesLoadingProc,
        getReportNew0, report0tree, error0tree,getOpkFull,

    } = props

    //dispatch for all reports at mounted
    React.useEffect(() => {
        // getReport0()
        // getReportNew0();
        getOpkNumbers()
        getOpkNumbers7()
        getOpkNames()
        getOpkFull()
        getOpkNumbersProc({opk_type: 'proceduralny'})
        getOpkNamesProc({opk_type: 'proceduralny'})

        // eslint-disable-next-line
    }, [])

    // report titles
    const titles = {
        0: "Zestawienie kosztów całkowitych OPK według rodzajów działalności",
        1: 'Raport po podziale kosztów',
        2: 'Sumaryczne zestawienie kosztów całkowitych ośrodków powstawania kosztów',
        3.1: 'Sumaryczne zestawienie kosztów rodzajowych według kont analitycznych - struktura',
        3.2: 'Sumaryczne zestawienie kosztów rodzajowych według kont analitycznych - dynamika',
        4: 'Koszt całkowity ośrodka powstawania kosztów - analityka',
        5: 'Koszty bezpośrednie ośrodka powstawania kosztów (analityka kont zespołu 4)',
        6: 'Koszty bezpośrednie ośrodków powstawania kosztów (grupy kosztów kont zespołu 4)',
        7: 'Koszty przeniesione na ośrodki powstawania kosztów poprzez zlecone usługi/procedury  - według ośrodka wykonującego',
        8: 'Koszty przeniesione na  ośrodki powstawania kosztów poprzez zlecone usługi/procedury - według ośrodka zlecającego',
        9: 'Zestawienie jednostkowych kosztów wytworzenia procedur medycznych',
        10: 'Koszty jednostkowe normatywne i koszty wytworzenia procedur medycznych - porównanie'
    }

    //ACTIVE REPORT
    const reportNumbers = [0, 1, 2, 3.1, 3.2, 4, 5, 6, 7, 8, 9, 10]
    //select for choosing report
    const options = []
    reportNumbers.forEach((key, i) => {
        options.push({value: Number(key), label: (i+1)+'. '+titles[key]})
    })
    const [singleSelect, setSingleSelect] = React.useState(options[0])
    //state with report number
    const [active, setActive] = React.useState(0) //current repor

    //typ dzialanosci
    const [opkTypes, setOpkType] = React.useState(['Podstawowa'])


    const chganeOpkTypeState = (opk) => {
        let tmpTypes = opkTypes;
        if (tmpTypes.includes(opk)) {
            tmpTypes = tmpTypes.filter(key => key !== opk)
            setOpkType(tmpTypes)

        } else {
            tmpTypes = [...tmpTypes, opk]
            setOpkType(tmpTypes)


        }
    }
    // const changeActive = el =>{ setActive(el); setSingleSelect({value:Number(el), label:titles[el]})}
    //state with active report data
    const [activeRepData, setActiveRepData] = React.useState(null)
    const changeChartData = () => {
        switch (active) {
            case 0:
                setActiveRepData({active: 0, dataChart: report0tree})
                break;
            case 1:
                setActiveRepData({active: 1, dataChart: report1})
                break;
            case 2:
                setActiveRepData({active: 2, dataChart: report2})
                break;
            case 3.1:
                setActiveRepData({active: 3.1, dataChart: report31})
                break;
            case 3.2:
                setActiveRepData({active: 3.2, dataChart: report32})
                break;
            case 4:
                setActiveRepData({active: 4, dataChart: report4})
                break;
            case 5:
                setActiveRepData({active: 5, dataChart: report5})
                break;
            case 6:
                setActiveRepData({active: 6, dataChart: report6})
                break;
            case 7:
                setActiveRepData({active: 7, dataChart: report7})
                break;
            case 8:
                let temp = null
                if(report8&&Object.getOwnPropertyNames(report8).length !== 0&&report82&&Object.getOwnPropertyNames(report82).length !== 0){
                    temp = {'rep8':report8, 'rep82':report82}
                    if(temp.rep8 === "No number selected"||temp.rep82 === 'No number selected') temp = "No number selected"
                }
                setActiveRepData({active: 8, dataChart: temp})
                break;
            case 9:
                setActiveRepData({active: 9, dataChart: report9})
                break;
            case 10:
                setActiveRepData({active: 10, dataChart: report10})
                break;
            default:
                setActiveRepData(null)
        }
    }
    React.useEffect(() => {
        changeChartData()
    }, [active])
    const [loadingChart, setloadingChart] = React.useState(true)
    React.useEffect(() => {
        if (!reportLoading) {
            setloadingChart(false, changeChartData())
            // changeChartData()
        } else if (!loadingChart) setloadingChart(true)
    }, [reportLoading])

    //REPORT MODES - miesięcznie czy narastająco (m/p)
    const getParams = (opk_number=null, name=null,mode=null) => {
        let params = {
            datebefore: moment(dateBefore).format("YYYY-MM"),
            dateafter: moment(dateFrom).format("YYYY-MM"),
        }
            
        if(mode) params.mode= mode
        if (!dateBefore) params['datebefore'] = ""
        if (!dateFrom) params['dateafter'] = ""
        params['opk_number'] = opk_number
        params['name'] = name

        return params
    }
    let temp = {}
    reportNumbers.forEach((no) => temp[no] = 'm')
    const [activeStates, setActiveStates] = React.useState(temp)
    const changeMode = (mode) => {
        if (activeStates[active] === mode) {
            return null
        } else {
            let temp = showOPK
            temp[active] = {}
            setShowOPK(temp)
            let newActive = activeStates
            newActive[active] = mode
            setActiveStates(newActive)
        }
        let params 
        switch (active) {
            case 2:
                return getReport2({"mode": mode})
            case 3.1:
                params = getParams(opkSelect.value, opkSelectName.value, mode)
                return getReport31(params)
            case 3.2:
                params = getParams(opkSelect.value, opkSelectName.value, mode)
                return getReport32(params)
            case 4:
                params = getParams(opkSelect.value, null, mode)
                return getReport4(params)
            case 5:
                params = getParams(opkSelect.value, opkSelectName.value, mode)
                return getReport5(params)
            case 6:
                params = getParams(opkSelect.value, opkSelectName.value, mode)
                return getReport6(params)
            case 7:
                params = getParams(opkSelect.value, opkSelectName.value, mode)
                return getReport7(params)
            case 8:
                params = getParams(null, null, mode)
                return getReport8(params)
            case 9:
                params = getParams(opkSelect.value, opkSelectName.value, mode)
                return getReport9(params)
            default:
                return null
        }
    }

    //to help rerender components
    const [refresh, setRefresh] = React.useState(false)
    React.useEffect(() => {
        setRefresh(!refresh)
    }, [reportLoading, nestedLoading])

    //toggle rows view
    temp = {}
    reportNumbers.forEach((no) => temp[no] = {})//empty {} for each report
    const [showOPK, setShowOPK] = React.useState(temp)
    const showOPKtoggle = (opk) => {
        let temp = showOPK
        if (showOPK[active][opk] !== undefined) { //if that opk was clicked before, toggle view on that row
            temp[active][opk] = !showOPK[active][opk]
            setShowOPK(temp)
            setRefresh(!refresh)
        } else { //first time for that opk -> get children from API
            let params = getParams(
                opkSelect.value !== ""?opkSelect.value:null, 
                opkSelectName.value!== ""?opkSelectName.value:null, 
                active!==1||active!==4?activeStates[active]:null)
            params.number=opk
            switch (active) {
                case 1:
                    getCode1(params)
                    break;
                case 3.1:
                    getCode31(params)
                    break;
                case 3.2:
                    getCode32(params)
                    break;
                case 4:
                    getCode4(params)
                    break;
                case 5:
                    getCode5(params)
                    break;
                case 6:
                    params['category'] = opk
                    params['number'] = null
                    getCode6(params)
                    break;
                default:
                    return 0
            }
            temp[active][opk] = true
            setShowOPK(temp)
            setRefresh(!refresh)
        }
    }

// METHODS AND STATES FOR FILTERS 
    const changeOPK = () => {
        temp = {}
        reportNumbers.forEach((no) => temp[no] = {})
        setShowOPK(temp)
        let params = getParams(opkSelect.value, opkSelectName.value, activeStates[active])
        // if(tableOpkNames[active].value===""){return null}
        // if(tableOpkNames[active].value===""){return null;}
        // temp = tableOpkNames
        // temp[active]={value:"",label:"wszystkie"}
        // setTableOpkNames(temp)
         const dict = {
                    "Podstawowa": [500, 501, 502, 503, 504, 505, 506, 508, 520, 521, 522, 523, 524, 525, 526, 527, 528, 529, 545],
                    "proceduralna": [507],
                    "medyczna": [530],
                    "niemedyczna": [535],
                    "Komercyjna": [540],
                    "Zarzad": [550],
                }
        switch (active) {
            case 0:

                params.opk_number = []
                opkTypes.map(opk => dict[opk].map(key => params.opk_number.push(key)))
                params.opk_number = params.opk_number.toString()
                // getReport0(params);
                getReportNew0(params)
                break;
            case 1:
                getReport1(params)
                break;
            case 2:
                params.opk_number = []
                opkTypes.map(opk => dict[opk].map(key => params.opk_number.push(key)))
                params.opk_number = params.opk_number.toString()

                getReport2(params)
                break;
            case 3.1:
                getReport31(params)
                break;
            case 3.2:
                getReport32(params)
                break;
            case 4:
                getReport4(params)
                // let nestedRows = ['dir_cost', 'koszt_dzial_medycz', 'koszt_dzial_niemedycz', 'procedural_cost']
                // nestedRows.forEach(nested=>{
                //     params.number = nested
                //     getCode4(params)
                // })
                break;
            case 5:
                getReport5(params)
                break;
            case 6:
                getReport6(params)
                break;
            case 7:
                getReport7(params)
                break;
            case 8:
                getReport8(params)
                break;
            case 9:
                getReport9(params)
                break;
            case 10:
                getReport10(params)
                break;
        }

    }
    const clearOPKnum = (value) => {
        setActive(Number(value['value']), setOpkSelect({value: "", label: "wszystkie"}))
        // clearOPK()
        setOpkSelectName({value: "", label: "wszystkie"})
        // if (opkSelect.value === ""){return null}
        // else {setOpkSelect({value:"",label:"wszystkie"})}
        // if(tableOpkNames[Number(value['value'])].value===""){return null}
        // temp = tableOpkNames
        // temp[Number(value['value'])]={value:"",label:"wszystkie"}
        // setTableOpkNames(temp)
        // setOpkSelect({value:"",label:"wszystkie"})
    }
    const clearOPK = () => {
        setOpkSelect({value: "", label: "wszystkie"}, clear2())
        // temp = tableOpkNames
        // temp[active]={value:"",label:"wszystkie"}
        // setTableOpkNames(temp)
    }
    const clear2 = () => {
        temp = tableOpkNames
        temp[active] = {value: "", label: "wszystkie"}
        setTableOpkNames(temp)
    }
//optionOPKNum
    const optionsOPK = [{value: "", label: "wszystkie"}]
    const firstPart = [3.1, 3.2, 4, 5, 6, 8]
    const secondPart = [9, 10]
    if (OpkFull && !OpkNumbersLoading && firstPart.includes(active)){ 
        OpkNumbers.forEach(opk => { optionsOPK.push({value: opk, label: opk+'   '+OpkFull[opk],name:OpkFull[opk]}) })
    }else if (OpkFull &&  !OpkNumbersLoadingProc && secondPart.includes(active)){ 
        OpkNumbersProc.forEach(opk => { optionsOPK.push({value: opk, label: opk+'   '+OpkFull[opk],name:OpkFull[opk]})
    })} else if(OpkFull &&  !OpkNumbers7Loading && active===7){
        OpkNumbers7.forEach(opk => { optionsOPK.push({value: opk, label: opk+'   '+OpkFull[opk],name:OpkFull[opk]}) })
    }

    // const optionsOPKnames = [{value: "", label: "wszystkie"}]
    // if (!OpkNamesLoading && firstPart.includes(active)) OpkNames.forEach(opk => {
    //     optionsOPKnames.push({value: opk, label: opk})
    // })
    // else if (!OpkNamesLoadingProc && secondPart.includes(active)) OpkNamesProc.forEach(opk => {
    //     optionsOPKnames.push({value: opk, label: opk})
    // })

//zapisywanie aktualnych opk
    var tempTable = {}
    reportNumbers.forEach((no) => tempTable[no] = {value: "", label: "wszystkie"})//empty {} for each report
    const [tableOpkNames, setTableOpkNames] = React.useState(tempTable)
    const setSelectNumTable = (value) => {
        temp = tableOpkNames
        temp[active] = value
        setTableOpkNames(temp)
    }
//dates filter
    const [dateFrom, setDateFrom] = React.useState("")
    const [dateBefore, setDateBefore] = React.useState("")
    registerLocale('pl', pl)
    const [opkSelect, setOpkSelect] = React.useState({value: "", label: "wszystkie"});
    const [opkSelectName, setOpkSelectName] = React.useState({value: "", label: "wszystkie"});
// React.useEffect(()=>{
//   filter('all')
// },[dateBefore,dateFrom])
    React.useEffect(() => {
        changeOPK()
    }, [opkSelect, dateBefore, dateFrom, opkTypes])
//collapsing filter elements
    const [openedCollapses, setOpenedCollapses] = React.useState([]);
// with this function we create an array with the opened collapses
// it is like a toggle function for all collapses from this page
    const collapsesToggle = (collapse) => {
        if (openedCollapses.includes(collapse)) {
            setOpenedCollapses(openedCollapses.filter((item) => item !== collapse));
        } else {
            openedCollapses.push(collapse);
            setOpenedCollapses([...openedCollapses, collapse]);
        }
    };
    // HTML

    useEffect(() => {
        changeChartData()
    }, [report0tree, report2])

    const getTitle = () => {
        let title = titles[active]
        if(opkSelect.hasOwnProperty("value") && opkSelect.value!== ""){
            title += " nr OPK "+opkSelect.value
        }
        if(dateFrom){
            title += " od "+( new Date(dateFrom).getMonth()+1)+"/"+new Date(dateFrom).getFullYear()
        }
        if(dateBefore){
            title+=" do "+( new Date(dateBefore).getMonth()+1)+"/"+new Date(dateBefore).getFullYear()
        }
        return title
    }

    return (
        <RaportsPage>
            <div className="content">
                {/* SELECT WHICH REPORT */}


                {/* FILTERS PLUS VISUALIZATION */}
                <Row>
                    <Col md="3">
                        <Card>
                            <CardBody>
                                <div aria-multiselectable={true} className="card-collapse" id="accordion"
                                     role="tablist">
                                    <CardTitle tag="h2" className={'h4'} style={{marginTop: '10px'}}>FILTRY</CardTitle>
                                    {(active == 0 || active == 2) &&
                                    <Card className="card-plain">
                                        <CardHeader role="tab">
                                            <a aria-expanded={openedCollapses.includes("collapseOne")}
                                               data-parent="#accordion"
                                               data-toggle="collapse" onClick={() => collapsesToggle("collapseOne")}>
                                                Rodzaj działalności{" "} <i className="nc-icon nc-minimal-down text-raporty"/>
                                            </a>
                                        </CardHeader>
                                        <Collapse role="tabpanel" isOpen={openedCollapses.includes("collapseOne")}>
                                            <CardBody className="raportyCheckBox">
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input checked={opkTypes.includes("Podstawowa")} type="checkbox"
                                                               onChange={e => chganeOpkTypeState("Podstawowa")}/> <span
                                                        className="form-check-sign"/> Podstawowa
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input checked={opkTypes.includes("proceduralna")}
                                                               type="checkbox"
                                                               onChange={e => chganeOpkTypeState("proceduralna")}/>
                                                        <span className="form-check-sign"/> Podstawowa proceduralna
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input checked={opkTypes.includes("medyczna")} type="checkbox"
                                                               onChange={e => chganeOpkTypeState("medyczna")}/> <span
                                                        className="form-check-sign"/> Pomocnicza medyczna
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input checked={opkTypes.includes("niemedyczna")}
                                                               type="checkbox"
                                                               onChange={e => chganeOpkTypeState("niemedyczna")}/> <span
                                                        className="form-check-sign"/> Pomocnicza niemedyczna
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input checked={opkTypes.includes("Komercyjna")} type="checkbox"
                                                               onChange={e => chganeOpkTypeState("Komercyjna")}/> <span
                                                        className="form-check-sign"/> Komercyjna
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input checked={opkTypes.includes("Zarzad")} type="checkbox"
                                                               onChange={e => chganeOpkTypeState("Zarzad")}/> <span
                                                        className="form-check-sign"/> Zarząd
                                                    </Label>
                                                </FormGroup>
                                            </CardBody>
                                        </Collapse>
                                    </Card>
                                    }
                                    {active !== 1 && active !== 2 && active !== 0 && <><Card className="card-plain">
                                        <CardHeader role="tab">
                                            <a aria-expanded={openedCollapses.includes("collapseTwo")}
                                               data-parent="#accordion"
                                               data-toggle="collapse" onClick={() => collapsesToggle("collapseTwo")}>
                                                Wybierz OPK{" "} <i className="nc-icon nc-minimal-down text-raporty"/>
                                            </a>
                                        </CardHeader>
                                        <Collapse role="tabpanel" isOpen={openedCollapses.includes("collapseTwo")}>
                                            <CardBody className='nowaOkr'>
                                                <Select
                                                    className="react-select select-raporty"
                                                    classNamePrefix="react-select"
                                                    name="opkSelect"
                                                    value={opkSelect}
                                                    onChange={(value) => {
                                                        setOpkSelect(value, setSelectNumTable(value));
                                                        setOpkSelectName({value: "", label: "wszystkie"})
                                                    }}
                                                    options={optionsOPK}
                                                    placeholder="wybierz"
                                                />
                                            </CardBody>
                                        </Collapse>
                                    </Card>
                                        {/*<Card className="card-plain">*/}
                                        {/*    <CardHeader role="tab">*/}
                                        {/*        <a aria-expanded={openedCollapses.includes("collapseTwoSec")}*/}
                                        {/*           data-parent="#accordion"*/}
                                        {/*           data-toggle="collapse"*/}
                                        {/*           onClick={() => collapsesToggle("collapseTwoSec")}>*/}
                                        {/*            OPK nazwa{" "} <i className="nc-icon nc-minimal-down text-raporty"/>*/}
                                        {/*        </a>*/}
                                        {/*    </CardHeader>*/}
                                        {/*    <Collapse role="tabpanel"*/}
                                        {/*              isOpen={openedCollapses.includes("collapseTwoSec")}>*/}
                                        {/*        <CardBody>*/}
                                        {/*            <Select*/}
                                        {/*                className="react-select primary"*/}
                                        {/*                classNamePrefix="react-select"*/}
                                        {/*                name="opkSelectName"*/}
                                        {/*                value={opkSelectName}*/}
                                        {/*                onChange={(value) => setOpkSelectName(value, setOpkSelect({*/}
                                        {/*                    value: "",*/}
                                        {/*                    label: "wszystkie"*/}
                                        {/*                }))}*/}
                                        {/*                options={optionsOPKnames}*/}
                                        {/*                placeholder="wybierz"*/}
                                        {/*            />*/}
                                        {/*        </CardBody>*/}
                                        {/*    </Collapse>*/}
                                        {/*</Card>*/}
                                    </>
                                    }
                                    {/*Miałem wyłączyć //SJ*/}
                                    {false &&
                                    <Card className="card-plain">
                                        <CardHeader role="tab">
                                            <a aria-expanded={openedCollapses.includes("collapseThree")}
                                               data-parent="#accordion"
                                               data-toggle="collapse" onClick={() => collapsesToggle("collapseThree")}>
                                                Podział kosztów{" "} <i className="nc-icon nc-minimal-down text-raporty"/>
                                            </a>
                                        </CardHeader>
                                        <Collapse role="tabpanel" isOpen={openedCollapses.includes("collapseThree")}>
                                            <CardBody  className="raportyCheckBox">
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input type="checkbox"/> <span
                                                        className="form-check-sign"/> bezpośrednie
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input type="checkbox"/> <span
                                                        className="form-check-sign"/> pośrednie procedur medycznych
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input type="checkbox"/> <span
                                                        className="form-check-sign"/> pośrednie działalności pomocniczej
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input checked type="checkbox"/> <span
                                                        className="form-check-sign"/> zarządu
                                                    </Label>
                                                </FormGroup>
                                            </CardBody>
                                        </Collapse>
                                    </Card>
                                    }
                                    <Card className="card-plain">
                                        <CardHeader role="tab">
                                            <a aria-expanded={openedCollapses.includes("collapseFour")}
                                               data-parent="#accordion"
                                               data-toggle="collapse" onClick={() => collapsesToggle("collapseFour")}>
                                                Zakres Czasowy{" "} <i className="nc-icon nc-minimal-down text-raporty"/>
                                            </a>
                                        </CardHeader>
                                        <Collapse role="tabpanel" isOpen={openedCollapses.includes("collapseFour")}>
                                            <CardBody>
                                                <Row>
                                                    <Col md="6" style={{paddingRight:"5px", paddingLeft:"5px"}}>
                                                        <FormGroup>
                                                            {/*<DatePicker */}
                                                            {/*  selected={dateFrom} */}
                                                            {/*  onChange={(date) => {setDateFrom(date)}}*/}
                                                            {/*  placeholderText="data początkowa"  */}
                                                            {/*  locale="pl"*/}
                                                            {/*  // calendarStartDay={1}*/}
                                                            {/*  className="dateInput"*/}
                                                            {/*  dateFormat="MM/yyyy"*/}
                                                            {/*  showMonthYearPicker*/}
                                                            {/*/>*/}
                                                            <ReactDatetime
                                                                inputProps={{
                                                                    className: "form-control okr",
                                                                    placeholder: "data początkowa",
                                                                    'aria-label': "data początkowa",
                                                                }}
                                                                dateFormat={"YYYY-MM"}
                                                                timeFormat={false}
                                                                locale="pl"
                                                                onChange={(date) => {
                                                                    setDateFrom(date)
                                                                }}
                                                                value={dateFrom}
                                                                className='dateSelectRaporty'
                                                            />


                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="6" style={{paddingLeft:"5px", paddingRight:"5px"}}>
                                                        <FormGroup>
                                                            {/*<DatePicker */}
                                                            {/*  selected={dateBefore} */}
                                                            {/*  onChange={(date) => {setDateBefore(date)}}*/}
                                                            {/*  placeholderText="data końcowa"  */}
                                                            {/*  locale="pl"*/}
                                                            {/*  // calendarStartDay={1}*/}
                                                            {/*  className="dateInput"*/}
                                                            {/*  dateFormat="MM/yyyy"*/}
                                                            {/*  showMonthYearPicker*/}
                                                            {/*/>*/}
                                                            <ReactDatetime
                                                                inputProps={{
                                                                    className: "form-control okr",
                                                                    placeholder: "data końcowa",
                                                                    'aria-label': "data końcowa",
                                                                }}
                                                                dateFormat={"YYYY-MM"}
                                                                timeFormat={false}
                                                                locale="pl"
                                                                onChange={(date) => {
                                                                    setDateBefore(date)
                                                                }}
                                                                value={dateBefore}
                                                                className='dateSelectRaporty'
                                                            />

                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Collapse>
                                    </Card>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="9">
                        <Row>
                            <Col style={{textAlign: "center"}} className='ml-auto mr-auto'>
                                <Card>
                                    <Row style={{
                                        margin: "auto",
                                        width: "100%",
                                        marginTop: "15px",
                                        marginBottom: "15px"
                                    }}>
                                        <Col style={{textAlign: "left", opacity: 1}} className='nowaOkr'>
                                            <Select
                                                className="react-select select-raporty"
                                                classNamePrefix="react-select"
                                                name="singleSelect"
                                                value={singleSelect}
                                                onChange={(value) => {
                                                    setSingleSelect(value);
                                                    clearOPKnum(value)
                                                }}
                                                aria-label={'Wybierz raport'}
                                                options={options}
                                                style={{singleValue: {opacity: 1}}}
                                                placeholder="Single Select"
                                            />
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                        <Card>
                            {active !== 1 &&
                            <CardBody className='justify-content-md-center' style={{minHeight: "500px"}}>
                                {loadingChart ?
                                    <Spinner/> :
                                    <>
                                        {activeRepData.dataChart !== "No number selected"&& activeRepData.dataChart &&!(active==0 && Object.keys(activeRepData.dataChart).length < 2 )  && (activeRepData.dataChart.length > 0 || Object.keys(activeRepData.dataChart).length > 0) ?

                                            <RaportVisualization data={activeRepData} opkNumber={opkSelect}
                                                                 startData={dateFrom}
                                                                  endData={dateBefore}
                                                                    extra={""}/> :
                                            <div style={{textAlign: 'center', marginTop: '200px'}}>
                                                {activeRepData.dataChart === "No number selected" ? <i>Wybierz OPK i określ zakres czasowy, aby wyświetlić wykres i tabelę</i> :
                                                    <i>{active !== 0 ?<>Brak danych dla wybranego OPK i zakresu czasowego</>:<>Brak danych dla wybranych kryteriów</>}</i>}
                                            </div>
                                        }
                                    </>
                                }
                            </CardBody>
                            }
                        </Card>
                    </Col>
                </Row>

                {/* BUTTON GROUP FOR SWITCHING REPORTS */}
                {/* <Row>
          <Col style={{textAlign:"center"}} className='col-md-9 ml-auto mr-auto'>
            <Card>
              <Row style={{margin:"auto", width:"100%", marginTop:"15px", marginBottom:"15px"}}>
                <Col style={{textAlign:"center"}}>
                <ButtonGroup  style={{width:'fit-content'}}>
                {reportNumbers.map(el=>{ 
                  return (
                    <Button className="btn-round" color="raporty" outline type="button" onClick={()=>changeActive(el)} 
                      style={active===el? {backgroundColor:"#17728d", color:"white"}: {}} key={`reportList${el}`} >
                      {el}
                    </Button>
                  )
                })}
              </ButtonGroup>
              </Col>
              </Row>
            </Card>
          </Col>
        </Row> */}

                {/* REPORT TABLES */}
                <Row>
                    <Col md="12">
                        {active !== 0 && <Card>
                            {activeRepData.dataChart !== "No number selected"&& activeRepData.dataChart &&
                                !(active==0 && Object.keys(activeRepData.dataChart).length < 2 )  &&
                                (activeRepData.dataChart.length > 0 || Object.keys(activeRepData.dataChart).length > 0) &&
                            <CardBody>
                                <Row>
                                    <Col>
                                        {/*Miałem wyłaczyć przycisk //SJ*/}
                                        {false && active !== 0 && active !== 1 && active !== 10 && <>
                                            <Button color="raporty" onClick={() => {
                                                changeMode('m')
                                            }} style={activeStates[active] === "m" ? activeStyle : {}}>
                                                Miesięcznie
                                            </Button>
                                            <Button color="raporty" onClick={() => {
                                                changeMode('p')
                                            }} style={activeStates[active] === "p" ? activeStyle : {}}>
                                                Narastająco
                                            </Button>
                                        </>}
                                        <div style={{fontWeight: 'bold', marginBottom:'5px', textAlign: 'center'}}> 
                                            {getTitle()}
                                        </div>
                                    </Col>
                                </Row>
                                <Row><Col>
                                    {/* {active===0 && <Report0 tableData={report0} refresh={refresh}></Report0>} */}
                                    {active === 1 &&
                                    <Report1 tableData={report1} showOPK={showOPK[1]} showOPKtoggle={showOPKtoggle}
                                             refresh={refresh} title={getTitle()}></Report1>}
                                    {active === 2 && <Report2 tableData={report2} refresh={refresh} title={getTitle()}></Report2>}
                                    {active === 3.1 &&
                                    <Report31 tableData={report31} showOPK={showOPK[3.1]} showOPKtoggle={showOPKtoggle}
                                              refresh={refresh} title={getTitle()}></Report31>}
                                    {active === 3.2 &&
                                    <Report32 tableData={report32} showOPK={showOPK[3.2]} showOPKtoggle={showOPKtoggle}
                                              refresh={refresh} title={getTitle()}></Report32>}
                                    {active === 4 && opkSelect.value!=="" && <>{report4 === "No number selected" ?
                                        <div>Żeby wyświetlić raport, wybierz numer OPK</div> :
                                        <Report4 tableData={report4} showOPK={showOPK[4]} showOPKtoggle={showOPKtoggle} refresh={refresh} 
                                            opk={opkSelect} parameters={getParams(opkSelect.value, null, activeStates[active])} title={getTitle()}> </Report4>}</>}
                                    {active === 5 &&
                                    <Report5 tableData={report5} showOPK={showOPK[5]} showOPKtoggle={showOPKtoggle}
                                             refresh={refresh} title={getTitle()}></Report5>}
                                    {active === 6 && <Report6 tableData={report6} refresh={refresh} showOPK={showOPK[6]}
                                                              showOPKtoggle={showOPKtoggle} title={getTitle()}></Report6>}
                                    {active === 7 &&
                                        <>{report7 === "No number selected" ?
                                            <div>Żeby wyświetlić raport, wybierz numer OPK</div> :
                                            <Report7 tableData={report7} refresh={refresh} title={getTitle()}></Report7>}
                                        </>}
                                    {active === 8 && (!reportLoading) &&
                                        <>{report8 === "No number selected" ?
                                            <div>Żeby wyświetlić raport, wybierz numer OPK</div> :
                                            <><Report8 tableData={report8} tableData2={report82} refresh={refresh} title={getTitle()}></Report8>
                                            {/* <Report8 tableData={report82} refresh={refresh} type='usług'></Report8> */}
                                        </>}
                                    </>}
                                    {active === 9 && <>{report9 === "No number selected" ?
                                        <div>Żeby wyświetlić raport, wybierz numer OPK</div> :
                                        <Report9 tableData={report9} refresh={refresh} title={getTitle()}></Report9>}</>}
                                    {active === 10 && <>{report10 === "No number selected" ?
                                        <div>Żeby wyświetlić raport, wybierz numer OPK</div> :
                                        <Report10 tableData={report10} refresh={refresh} title={getTitle()}></Report10>}</>}
                                </Col></Row>
                            </CardBody>}
                        </Card>}
                    </Col>
                </Row>
            </div>
        </RaportsPage>
    );
}

const activeStyle = {
    backgroundColor: "#104f61 ", color: "white", textDecoration: "underline"
}

const mapStateToProps = state => ({
    reportLoading: state.reportReducer.reportLoading,
    nestedLoading: state.reportReducer.nestedLoading,
    OpkFull: state.filterOPKReducer.OpkFull,
    report0: state.reportReducer.report0,
    report1: state.reportReducer.report1,
    report2: state.reportReducer.report2,
    report31: state.reportReducer.report31,
    report32: state.reportReducer.report32,
    report4: state.reportReducer.report4,
    report5: state.reportReducer.report5,
    report6: state.reportReducer.report6,
    report7: state.reportReducer.report7,
    report8: state.reportReducer.report8,
    report82: state.reportReducer.report82,
    report9: state.reportReducer.report9,
    report10: state.reportReducer.report10,
    OpkNumbers: state.filterOPKReducer.OpkNumbers,
    OpkNumbersLoading: state.filterOPKReducer.OpkNumbersLoading,
    OpkNumbers7: state.filterOPKReducer.OpkNumbers7,
    OpkNumbers7Loading: state.filterOPKReducer.OpkNumbers7Loading,
    OpkNames: state.filterOPKReducer.OpkNames,
    OpkNamesLoading: state.filterOPKReducer.OpkNamesLoading,
    OpkNumbersProc: state.filterOPKReducer.OpkNumbersProc,
    OpkNumbersLoadingProc: state.filterOPKReducer.OpkNumbersLoadingProc,
    OpkNamesProc: state.filterOPKReducer.OpkNamesProc,
    OpkNamesLoadingProc: state.filterOPKReducer.OpkNamesLoadingProc,
    report0tree: state.reportReducer.report0tree,
    error0tree: state.reportReducer.error0tree
})

export default connect(mapStateToProps, {
    getReportNew0,
    getReport0,
    getReport1, getCode1,
    getReport2,
    getReport31, getCode31,
    getReport32, getCode32,
    getReport4, getCode4,
    getReport5, getCode5,
    getReport6, getCode6,
    getReport7,
    getReport8,
    getReport9,
    getReport10,
    getOpkNumbers,
    getOpkNumbers7,
    getOpkNames,
    getOpkNumbersProc,
    getOpkNamesProc,
    getOpkFull
})(NewRaport)
